import styles from "../styles/settingsImageGallery.module.css";

export const SettingsImageGallery = () => {
  return <div className={styles.wrapper}>Image gallery page coming soon!</div>;
};
